export default __webpack_public_path__ + "static/media/para-logo-mobile.3f65e38a.svg";